import type { ReactNode } from "react";
import { useTracker } from "@ferrivia/auth-web";
import { useMarket } from "@ferrivia/i18n";
import type { QuestionnaireSummaryCta } from "@ferrivia/api-contract";
import { coachBookingUrl } from "../lib/bookingLinks";
import s from "./CtaButton.module.css";

export interface CtaButtonProps {
  path: QuestionnaireSummaryCta;
  onOpenBooking: () => void;
  children: ReactNode;
}

export function CtaButton({ path, onOpenBooking, children }: CtaButtonProps) {
  const tracker = useTracker();
  const market = useMarket();

  function track() {
    tracker.track("summary.cta_clicked", { path });
  }

  if (path === "support") {
    return (
      <a className={s.cta} href={coachBookingUrl(market)} target="_blank" rel="noreferrer" onClick={track}>
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={s.cta}
      onClick={() => {
        track();
        onOpenBooking();
      }}
    >
      {children}
    </button>
  );
}
